<div class="header2 hoverarea" *ngIf="isHeader">

    <ng-content select=".list-header"></ng-content>

    <btn *ngIf="m_viewDetailsBtn && list && (list.length > 0 || (list | keys).length > 0 )"
         label="Détails"
         type="actionMore"
         (click)="m_viewDetailsFlag = !m_viewDetailsFlag"
         class="hovervisible">
        <span class="icon">
            <fa-icon [icon]="m_viewDetailsFlag ? iconEyeSlash : iconEye"></fa-icon>
        </span>
    </btn>
    <btn *ngIf="m_viewDetailsBtn && ( !list || (list.length === 0 || (list | keys).length === 0 ) )"
         label="Liste vide"
         type="invisible"
         (click)="m_viewDetailsFlag = !m_viewDetailsFlag">
        <span class="icon">
            <fa-icon [icon]="iconExclamation"></fa-icon>
        </span>
    </btn>

</div>
<ng-content select=".list-notification"></ng-content>
<div *ngIf="list">
    <div *ngFor="let item of (list | values)" class="list-row style-2">

        <traveller *ngIf="type === 'traveller'"
                   [travellerItem]="item"
                   [travellerKey]="item.xID"
                   [showDetails]="m_viewDetailsFlag"
                   [showErrors]="showErrors"
                   [useApis]="useApis"
                   [isError]="isError[item.xID]"></traveller>

        <traveller-synchronyme *ngIf="type === 'travellersynchronyme'"
                               [travellerItem]="item"
                               [travellerKey]="item.xID"
                               [showDetails]="m_viewDetailsFlag"
                               (showTnrEvent)="showTnr($event)"
                               (removePax)="removeMe(item.id, $event)"></traveller-synchronyme>


    </div>
</div>
